import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {FAQPage} from '../../modules/main/FAQPage'

const FAQPageWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.FAQPAGE'})}</PageTitle>
      <FAQPage />
    </>
  )
}

export {FAQPageWrapper}
